<template>
  <div id="componentColorContainer">
    <el-color-picker
        popper-class="popperClass"
        style="visibility: hidden"
        @active-change="activeChange"
        ref="elColorPicker"
        v-model="color">
    </el-color-picker>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name:'componentColor',

  data () {
    return {
      color: '',
    }
  },


  computed : {
    ...mapState({
      currentComponent: state => state.monge.currentComponent
    })
  },

  mounted () {
    this.$refs.elColorPicker.hide = () => {}
    const obj = document.querySelector(".popperClass .el-color-dropdown__btns .el-color-dropdown__btn>span");
    if (obj) {
      obj.innerHTML = '关 闭'
    }
  },

  methods : {
    open () {
      this.$refs.elColorPicker.showPicker = true
    },

    close () {
      this.$refs.elColorPicker.showPicker = false
    },


    to16Color (color) {
      const rgb = color.split(',');
      const r = parseInt(rgb[0].split('(')[1]);
      const g = parseInt(rgb[1]);
      const b = parseInt(rgb[2].split(')')[0]);
      const hex = "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      return hex;
    },


    activeChange (color) {
      let newColor = this.to16Color(color)
      color = color.slice(1)
      color = parseInt(color,16)
      const {modelId, elementId} = this.currentComponent
      if (modelId && elementId) {
        Monge.Model.ElementOperator.setColor(modelId,elementId,newColor)
      } else {
        this.$message.warning('请先选择您想要设置颜色的构件')
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  #componentColorContainer{
    position fixed
    right  0
    bottom -30px
    transform translateX(-50%)
    /deep/ .el-color-picker__trigger{
      width 1px
      height 1px
    }
  }
</style>

<style lang="scss" >
.popperClass .el-color-dropdown__link-btn{
  display: none;
}
</style>
